module.exports = "/_next/static/images/04d9a6c028c95c8de52b14345561199d-hero-lg.jpg.webp";